import HistorySectionStatus from 'components/Content/BeautyInsider/BeautyInsiderHistory/HistorySectionStatus/HistorySectionStatus';

export default HistorySectionStatus;
